import { useSettings } from '@backpackjs/storefront';

import { Link } from '../../../snippets';
import { RegisterForm } from './RegisterForm';

export function Register() {
  const settings = useSettings();
  const { loginText, loginLinkText } = {
    ...settings?.account?.register,
  };

  return (
    <div className="px-contained py-contained flex flex-col items-center">
      <div className="mx-auto grid w-full max-w-[28rem] grid-cols-1 gap-5 md:max-w-[64rem]">
        <div className="px-contained py-contained">
          <RegisterForm />
        </div>
      </div>

      <div className="mt-6 flex flex-wrap justify-center gap-x-1.5">
        <p>{loginText}</p>
        <Link
          aria-label="Go to login page"
          className="text-underline font-bold"
          href="/account/login"
        >
          {loginLinkText}
        </Link>
      </div>
    </div>
  );
}

Register.displayName = 'Register';
